import { ConfigProvider } from 'antd';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './App.css';
import Router from './Routes';
import { persistOptions, queryClient } from './query/queryClient';
import { customTheme } from './theme';
import { store } from './store/store';

function App() {
  return (
    <ConfigProvider theme={customTheme}>
      <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
        <Provider store={store}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </Provider>
      </PersistQueryClientProvider>
    </ConfigProvider>
  );
}

export default App;
